import React from 'react';
import auth from './auth';
import config from './Config/Config';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import { Prompt } from 'react-router-dom';
import PersonalDetailsIcon from '../Resources/Home_Icons/PersonalDetailsIcon.png';
import PreferencesIcon from '../Resources/Home_Icons/PreferencesIcon.png';
import RewardsIcon from '../Resources/Home_Icons/RewardsIcon.png';
import ReferIcon from '../Resources/Home_Icons/ReferIcon.png';
import AppIcon from '../Resources/Home_Icons/AppIcon.png';
import SettingsIcon from '../Resources/Home_Icons/SettingsIcon.png';
import CardIcon from '../Resources/Home_Icons/CardIcon.png';
import { useAlert } from 'react-alert';
import { Password } from './Home/Children/Password';
import { Setting2 } from './Home/Children/Setting2';

export const Home = props =>{
  const [firstName, setFirstName] = React.useState('');
  
  // let [responseNameData, setResponseNameData] = React.useState('');
  const [memberWarning, setMemberWarning] = React.useState(false);
  const [memberExpired, setMemberExpired] = React.useState(false);
  const [savePreferences, setSavePreferences] = React.useState(false);
  const [saveDetails, setSaveDetails] = React.useState(false);

  // const [mobile, setMobile] = React.useState(window.innerWidth < 600);
  // const [homeIcon, setHomeIcon] = React.useState('fa-10x');

  const [expiryMonth, setExpiryMonth] = React.useState('');

  //Modal
  const [showModal, setShowModal] = React.useState(false);
  const [modalSetting, setModalSetting] = React.useState(1);

  //Force password reset
  //const [forcePassword, setForcePassword] = React.useState(false);

  //Sets free memberships
  const [freeMembership, setFreeMembership] = React.useState(false);

  React.useEffect(() => {
    setFreeMembership(config.getFreeMembershipConfig());

    // console.log(sessionStorage.getItem('memberNumber'));
    if('parentIFrame' in window){
      window.parentIFrame.scrollTo(0, 0);
    }

    const  headers =  {
      token: sessionStorage.getItem('token'),
      memberNumber: sessionStorage.getItem('memberNumber')
    }

    fetch(localStorage.getItem('server') + 'member', {
      method: 'GET',
      headers
    })
    .then(function(resp){
      return resp.json();
    })
    .then(function(data){
      if(data.status === 401){
        // console.log("Invalid Token - Redirecting to login");
        // props.history.push("");
        alert.show(
          <span ref={sessionRef}>
              Your session has expired. Please login to continue.
          </span>
          , {
              title: "Session Expired"
      });
      } else if(data.status === 429){
        alert.show(
            <span ref={sessionRef}>
                Too many requests. Please try again later.
            </span>
            , {
                title: "Uh Oh..."
        });
    } else {
        console.info(data);
        auth.setCurrent(data.current);
        setFirstName(data.member.firstName);
        sessionStorage.setItem('isDigital', data.digital.valueBool);

        if(props.location.saveDetails){
          setSaveDetails(true);
          window.setTimeout(() => {
            setSaveDetails(false);
            props.location.saveDetails = false;
          }, 5000);
        }
        if(props.location.savePref){
          setSavePreferences(true);
          window.setTimeout(() => {
            setSavePreferences(false);
            props.location.savePref = false;
          }, 5000);
        }
      }

      //Check if the member has to reset their password
      // if(data.passwordReset && data.passwordReset === true){
      //   setForcePassword(true);
      // }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    // Start of redirects
    const redirectRefer = () =>{
      redirectTo("referFriend");
    }

    const redirectPoints = () =>{
      redirectTo("points");
    }

     const redirectRenew = () =>{
       redirectTo("renew");
     }

     const redirectCard = () =>{
      redirectTo("card");
    }

    const redirectDetails = () =>{
      redirectTo("details");
    }

    const redirectSubscriptions = () =>{
      redirectTo("subscriptions");
    }

    const redirectDownloadApp = () =>{
      redirectTo("app");
    }

    function redirectTo(page){
      props.history.push("/"+page);
    }
    //End of redirects

    const logout = () =>{
      fetch(localStorage.getItem('server') + 'logout',{
        method: 'PUT',
        headers: {
          token: sessionStorage.getItem('token'),
          memberNumber: sessionStorage.getItem('memberNumber')
        }
      })
      .then(function(){
        document.cookie = "redirect=";
        document.cookie = "auth-token=";
        auth.logout(() =>{
          props.history.push("");
        });
      });
    }

    const sessionRef = (node)=>{
      if(node === null){
        window.location.replace(window.location.origin);
      }
    }

    const alert = useAlert();

    //Modal functions
    const openModal = ()=>{
      setShowModal(true);
    }

    const closeModal = ()=>{
      setShowModal(false);
    }

    // const forceModal = (complete = false)=>{
    //   if(complete){
    //     setForcePassword(false);
    //   }
    // }

    return (
        <div className="container">
          <Prompt
            message={(location, action) => {
              if (action === 'POP') {
                return location.pathname === "/"
                ? `Do you wish to log out?`
                : true
              }
            }}
          />
          <div hidden={!savePreferences}>
            <Alert variant="success">
              <Alert.Heading className="text-center">Success!</Alert.Heading>
              <p className="text-center">Your preferences has been saved</p>
            </Alert>
          </div>
          <div hidden={!saveDetails}>
            <Alert variant="success">
              <Alert.Heading className="text-center">Success!</Alert.Heading>
              <p className="text-center">Your details has been updated</p>
            </Alert>
          </div>
          {/* <h2 className="text-center"><strong>HOMEPAGE</strong></h2> */}
          <div className="d-flex justify-content-center">
            <h1 id="gtm-home" className="home-heading-element">Hi {firstName}</h1>
            <i className="fas fa-chevron-down settings-chevron home-heading-element" onClick={openModal}></i>
          </div>

          {!freeMembership &&
          <div>
          <div hidden={!memberWarning}>
            <Alert variant="warning" onClose={() => setMemberWarning(false)} dismissible>
              <Alert.Heading>Your Membership Will Expire Soon!</Alert.Heading>
              <p className="text-justify">Your membership expires <strong>{expiryMonth === 2 ? <span>in 2 months</span> : expiryMonth === 1 ? <span>next month</span> : <span>this month</span>}</strong>. <u className="point-cursor" onClick={redirectRenew}>Click here</u> to renew. If you aren’t ready to renew just yet, be sure to look out for a reminder from us in the coming weeks. <u className="point-cursor" onClick={redirectDetails}>Click here</u> to check your details are up to date so you don’t miss out!</p>
            </Alert>
          </div>
          <div hidden={!memberExpired}>
            <Alert variant="danger" onClose={() => setMemberExpired(false)} dismissible>
              <Alert.Heading>Your Membership Has Expired!</Alert.Heading>
              <p className="text-justify">You’re membership has expired. But don’t worry, you can renew by <u className="point-cursor" onClick={redirectRenew}>clicking here</u> – we’d love to have you back!</p>
            </Alert>
          </div>
          </div>
          }


          <br/>
          <div className="row">
            <div className="homeBlock col-md-4 col-6" onClick={redirectDetails}>
              {/* <i className={mobile ? "fa fa-clipboard-list fa-5x" : "fa fa-clipboard-list fa-10x"}></i> */}
              <img src={PersonalDetailsIcon} alt='Personal Details'/>
              <h5 className="homeText">Personal Details</h5>
            </div>
            <div className="homeBlock col-md-4 col-6" onClick={redirectSubscriptions}>
              {/* <i className={mobile ? "fa fa-envelope-open fa-5x" : "fa fa-envelope-open fa-10x"}></i> */}
              <img src={PreferencesIcon} alt='Preferences' />
              <h5 className="homeText">Preferences</h5>
            </div>
            <div className="homeBlock col-md-4 col-6" onClick={redirectPoints}>
              {/* <i className={mobile ? "fa fa-money-bill-alt fa-5x" : "fa fa-money-bill-alt fa-10x"}></i> */}
              <img src={RewardsIcon} alt='Rewards' />
              <h5 className="homeText">Rewards</h5>
            </div>
            <div className="homeBlock col-md-4 col-6" onClick={redirectRefer}>
              {/* <i className={mobile ? "fa fa-users fa-5x" : "fa fa-users fa-10x"}></i> */}
              <img src={ReferIcon} alt="Refer" />
              <h5 className="homeText">Refer a Friend</h5>
            </div>
            <div className="homeBlock col-md-4 col-6" onClick={redirectDownloadApp}>
              {/* <i className={mobile ? "fa fa-mobile-alt fa-5x" : "fa fa-mobile-alt fa-10x"}></i> */}
              <img src={AppIcon} alt="App" />
              <h5 className="homeText">Our App</h5>
            </div>

            <div className="homeBlock col-md-4 col-6" onClick={redirectCard}>
              {/* <i className={mobile ? "fa fa-redo fa-5x" : "fa fa-redo fa-10x"}></i> */}
              <img src={CardIcon} alt="Card"/>
              <h5 className="homeText">Digital Card</h5>
            </div>

            {/* <div className="test-block col-md-4 col-sm-6">
              <img className="homeImg test-bg" src="https://picsum.photos/1925/1085" />
              <h3 className="test"><strong>Test</strong></h3>
            </div> */}


          </div>
          {/* <div className="d-flex justify-content-center logout-bar">
            <button className="btn btn-outline-dark logoutBtn" onClick={logout}>Logout</button>
            <i className="fas fa-cog fa-2x settings-cog" onClick={openModal}></i>
          </div> */}

          {/* Force password reset modal */}
          {/* <Modal size="lg" show={forcePassword} onHide={forceModal} centered >
            <Modal.Body>
              <Container>
                <Password forced={true} closeModal={forceModal} firstName={firstName} />
              </Container>
            </Modal.Body>
          </Modal> */}

          {/* Settings Modal */}
          <Modal size="lg" show={showModal} onHide={closeModal} centered >
            <Modal.Header className="modal-center">
              <button className="btn btn-outline-dark modal-logout point-cursor" onClick={logout}>Logout</button>
              <h1 className="modal-setting-heading">Settings</h1>
              <button className="btn btn-outline-dark modal-close-btn point-cursor" onClick={closeModal}>Close</button>
            </Modal.Header>
            <Modal.Body className="">
              <Container>
                {/* <div className="d-flex justify-content-center btn-group btn-group-toggle" data-toggle="buttons">
                  <button className="btn btn-outline-dark" onClick={()=>setModalSetting(1)}>Change Password</button>
                  <button className="btn btn-outline-dark" onClick={()=>setModalSetting(2)}>Setting 2</button>
                </div> */}
                <div className="modal-settings-children">
                  {modalSetting === 1 && <Password />}
                  {modalSetting === 2 && <Setting2 />}
                </div>
              </Container>
            </Modal.Body>
          </Modal>

        </div>
      );
}